// The purchase key (custom_id) used to travel as /order-success?id=<key>, where
// every analytics tag on the page recorded it. Navigations inside the app now
// leave it in sessionStorage instead; links from the payment gateways still
// arrive with ?id=, and the success page moves it here and cleans the URL.
const ORDER_SUCCESS_ID_KEY = 'avantti:order-success-id';

export const rememberOrderSuccessId = (customId: string): void => {
  try {
    sessionStorage.setItem(ORDER_SUCCESS_ID_KEY, customId);
  } catch {
    // Private mode or storage disabled: the page then relies on the URL.
  }
};

export const readOrderSuccessId = (fromUrl: string | null): string | null => {
  if (fromUrl) {
    return fromUrl;
  }
  try {
    return sessionStorage.getItem(ORDER_SUCCESS_ID_KEY);
  } catch {
    return null;
  }
};

// Checkout nuevo: el resultado vive dentro del mismo recorrido del evento
// (/events/<slug>/orders/new/resultado), así pasar de Pago al resultado y
// volver no cambia de página de Next. Mismo guardado de la clave que abajo.
export const orderResultPath = (eventSlug: string, customId: string, extraParams: Record<string, string> = {}): string => {
  const path = `/events/${eventSlug}/orders/new/resultado`;
  rememberOrderSuccessId(customId);
  const params = new URLSearchParams(extraParams);
  if (readOrderSuccessId(null) !== customId) {
    params.set('id', customId);
  }
  const query = params.toString();
  return query ? `${path}?${query}` : path;
};

// Where to send the buyer after a purchase. Falls back to the old ?id= URL when
// the key cannot be stored, so the success page always finds the order.
export const orderSuccessPath = (customId: string, { admin = false } = {}): string => {
  const path = admin ? '/admin/order-success' : '/order-success';
  rememberOrderSuccessId(customId);
  return readOrderSuccessId(null) === customId ? path : `${path}?id=${customId}`;
};
